export const defaultState = () => ({});

export const state = () => defaultState();

export const getters = {};

export const mutations = {};

export const actions = {
    resetPhoneLink(vuexCtx, data) {
        return this.$axios.$post('/auth/phone-reset-link', data);
    },

    resetPhone(vuexCtx, data) {
        return this.$axios.$post('/auth/phone-reset', data);
    },

    update(vuexCtx, data) {
        return this.$axios.$post('/auth/profile', data);
    },

    register(vuexCtx, data) {
        return this.$axios.$post('/auth/register', data);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
